function _translateCondition(condition) {
  const map = {
    eq: "==",
    ne: "!=",
    gt: ">",
    gte: ">=",
    lt: "<",
    lte: "<=",
  };
  return map[condition];
}

// https://stackoverflow.com/a/175787
function isNumeric(str) {
  if (typeof str != "string") return false; // we only process strings!
  return (
    !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
    !isNaN(parseFloat(str))
  ); // ...and ensure strings of whitespace fail
}

function _translateLogic(condition) {
  const map = {
    and: "&&",
    or: "||",
  };
  return map[condition];
}

/**
 *
 * Validate Show Hide
 *
 * Basically this checks for status, role and condition rules. They are handled server-side as oppose to client-side showHide (which deals with components).
 * We have seperate show hide for security reasons, i.e. not to push unwanted data to the frontend.
 *
 * @param {*} param0
 */

//eslint-disable-next-line
module.exports = function validateShowHide3({
  node,
  clientSide,
  serverSide,
  context = {},
  isAdmin = false,
  extraField = "showHide",
  inverted = false,
}) {
  const isEmpty = require("lodash/isEmpty");
  const intersection = require("lodash/intersection");
  const get = require("lodash/get");
  const extraVariable = get(node, ["extra", extraField], {});
  const { clientConditions = [], serverConditions = [] } = extraVariable;

  if (clientSide && serverSide) {
    throw new Error("Cannot select clientside or serverside, not both");
  }

  if (!clientSide && !serverSide) {
    throw new Error("you have to select at lease client or serverside");
  }

  if (clientSide && isEmpty(clientConditions)) {
    return inverted ? false : true;
  }

  let conditions = clientSide ? clientConditions : serverConditions;

  const { roles, pdf, effects, formData } = context;

  let str = "";

  if (conditions.length === 0) {
    return inverted ? false : true;
  }

  let inCondition = false;

  for (let i = 0; i < conditions.length; i++) {
    const c = conditions[i];

    if (c.type === "status") {
      const { condition, rightValue, nextLogic } = c;

      if (!formData["status"]) {
        return inverted ? true : false;
      }

      str += `"${formData["status"]}" ${_translateCondition(
        condition
      )} "${rightValue}"`;

      if (nextLogic && i !== conditions.length - 1) {
        str = `${str} ${_translateLogic(nextLogic)} `;
      }
    } else if (c.type === "role") {
      /**
       * Check for roles
       *
       * Here we do an intersection between roles (passed in) and the rightValue which contains the user specified roles.
       * Note that we check against the condition (eq,ne) in the code and not in the eval. I.e the result of this is a TRUE / FALSE value
       * which is added to the str for eval(str)
       *
       */
      let { condition, rightValue, nextLogic } = c;

      if (isEmpty(roles)) {
        str += ` false `;

        if (nextLogic && i !== conditions.length - 1) {
          str = `${str} ${_translateLogic(nextLogic)} `;
        }

        continue;
      }

      // convert roles (rightValue) to arrays
      if (!Array.isArray(rightValue)) {
        rightValue = [rightValue];
      }

      // 2021-01-04: Added r.toString() in order to convert roles objectIds to string before intersecting
      const roleIntersect = intersection(
        roles.map((r) => r.toString()),
        rightValue.map((r) => r.toString())
      );

      if (roleIntersect.length > 0) {
        // we match the role
        if (condition === "eq") {
          str += ` true `;
        } else {
          str += ` false `;
        }
      } else {
        // we do NOT match the role
        if (condition === "eq") {
          str += ` false `;
        } else {
          str += ` true `;
        }
      }

      if (nextLogic && i !== conditions.length - 1) {
        str = `${str} ${_translateLogic(nextLogic)} `;
      }
    } else if (c.type === "component") {
      const {
        leftValue,
        condition,
        rightValue,
        nextLogic,
        fromRepeat = false,
      } = c;

      let _leftValue = fromRepeat
        ? get(formData, leftValue)
        : formData[leftValue];

      const isArrayValue =
        _leftValue && Array.isArray(_leftValue) && _leftValue.length > 1;

      // If _leftValue is array we need to handle each left value separately
      if (isArrayValue) {
        // If _leftValue is array we will check for multiple values and therefore need to wrap
        // the expression inside parentheses so that it is evaluated by its own
        str += "(";

        // Creates a validation for each value in the _leftValue array
        for (let i = 0; i < _leftValue.length; i++) {
          if (Number.isInteger(parseInt(rightValue)) && !isNaN(rightValue)) {
            str += `"${_leftValue[i]}" ${_translateCondition(
              condition
            )} ${rightValue}`;
          } else {
            str += `"${_leftValue[i]}" ${_translateCondition(
              condition
            )} "${rightValue}"`;
          }

          str += " || ";
        }
      }

      // Replace double quotes with single quotes and removes line breaks
      if (_leftValue && typeof _leftValue === "string") {
        _leftValue = _leftValue.replace(/"/g, "'");

        _leftValue = _leftValue.replace(/\r?\n|\r/g, " ");
      }

      if (Number.isInteger(parseInt(rightValue)) && !isNaN(rightValue)) {
        str += `"${_leftValue}" ${_translateCondition(
          condition
        )} ${rightValue}`;
      } else {
        str += `"${_leftValue}" ${_translateCondition(
          condition
        )} "${rightValue}"`;
      }

      // Closing parenthes that is opened on row 170
      if (isArrayValue) str += ")";

      if (nextLogic && i !== conditions.length - 1) {
        str = `${str} ${_translateLogic(nextLogic)} `;
      }
    } else if (c.type === "variable") {
      const { leftValue, condition, rightValue, nextLogic } = c;

      if (isAdmin && leftValue.includes("effects")) {
        str += "true ";

        continue;
      }

      // check against handlebar variabel
      const handlebars = require("handlebars");
      const _lhTemplate = handlebars.compile(`{{${leftValue}}}`);
      const _rhTemplate = handlebars.compile(rightValue);

      const isNum = isNumeric(rightValue);

      context.source = pdf ? "pdf" : isAdmin ? "admin" : context.source;
      context.effects = effects;

      const _leftValue = _lhTemplate(context);
      const _rightValue = _rhTemplate(context);

      if (isNum) {
        str += `${_leftValue || undefined} ${_translateCondition(
          condition
        )} ${_rightValue}`;
      } else {
        str += `"${_leftValue}" ${_translateCondition(
          condition
        )} "${_rightValue}"`;
      }

      if (nextLogic && i !== conditions.length - 1) {
        str = `${str} ${_translateLogic(nextLogic)} `;
      }
    } else if (c.type === "condition") {
      /**
       * Check for conditions. This wraps the str with () and add the correct and/or (&&/||) to the str
       */

      const { rightValue } = c;

      // are we in a condition already, then close out the condition first
      if (inCondition) {
        str = `${str.substring(0, str.length - 3)}) ${_translateLogic(
          rightValue
        )} (`;
      } else {
        str = `(${str.substring(0, str.length - 3)}) ${_translateLogic(
          rightValue
        )} (`;
      }

      inCondition = true;
    }
  }

  if (inCondition) {
    // if last conditio  is '(' then ensure to include true
    if (str.slice(-1) === "(") {
      str += "true)";
    } else {
      str += ")";
    }
  }

  // eslint-disable-next-line
  if (eval(str)) {
    return true;
  } else {
    return false;
  }
};
